import axios from "axios";
import { USER_BASE_URL } from "../urls/authUserUrl";
import Cookies from "js-cookie";
const instance = axios.create({
  baseURL: USER_BASE_URL,
  withCredentials: true,
});

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // const token = Cookies.get("access_token");

    // if (token) {
    //   config.headers["Authorization"] = token;
    // }
    return window.navigator.onLine
      ? config
      : Promise.reject({
          response: {
            data: {
              message: "Check your internet connection",
            },
          },
        });
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (
      error?.response?.status === 403 ||
      error?.response?.status === 401
    ) {
      Cookies.remove("access_token");
      window.location.href = "/login";
      localStorage.removeItem("loggedInUser");
      return error;
    } else if (
      error?.response?.status === 404 ||
      error?.response?.status === 400
    ) {
      return error?.response;
    } else {
      return Promise.reject(error.response);
    }
  }
);

export default instance;
